import React from 'react';
import img1 from '../../../assets/img/jobs/slider1.jpg';
import img2 from '../../../assets/img/jobs/ticker2.jpg';
import img3 from '../../../assets/img/jobs/ticker3.jpg';
import img4 from '../../../assets/img/jobs/ticker4.jpg';
import img5 from '../../../assets/img/jobs/ticker5.jpg';
import img6 from '../../../assets/img/jobs/ticker1.jpg';
import s from './PhotoTicker.module.scss';

const PhotoTicker = () => {
  return (
    <>
      <div className={s.ticker}>
        <div className={s.wrapperPhotos}>
        {/* обязательно два элемента и они должны быть одинаковыми */}
          <div className={s.photos}>
            <img  className={s.img} src={img1} alt={`1-1`}/>
            <img  className={s.img} src={img2} alt={`2-1`}/>
            <img  className={s.img} src={img3} alt={`3-1`}/>
            <img  className={s.img} src={img4} alt={`4-1`}/>
            <img  className={s.img} src={img5} alt={`5-1`}/>
            <img  className={s.img} src={img6} alt={`6-1`}/>
          </div>
          <div className={s.photos}>
            <img  className={s.img} src={img1} alt={`1-2`}/>
            <img  className={s.img} src={img2} alt={`2-2`}/>
            <img  className={s.img} src={img3} alt={`3-2`}/>
            <img  className={s.img} src={img4} alt={`4-2`}/>
            <img  className={s.img} src={img5} alt={`5-2`}/>
            <img  className={s.img} src={img6} alt={`6-2`}/>

          </div>
        </div>
      </div>
    </>

    
  )
}

export default PhotoTicker;